export const stripReactIdOfColon = (str: string): string => str.replaceAll(':', '');
